import { FormField } from '@/global/components/Form'
import { RadioAccordion as RA } from '@/global/components/ui/Accordion'
import { Label } from '@/global/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/global/components/ui/radio-group'
import { cn } from '@/lib/utils'
import { TrocaAutomaticaTabela } from '@/service/api'
import dayjs from 'dayjs'
import { useFormContext } from 'react-hook-form'

export default function AccordionRepetir() {
    const {
        watch,
        setValue,
        formState: { errors = {} },
    } = useFormContext<TrocaAutomaticaTabela>()

    const [
        dataInicial,
        tipoRepeticao,
        repeticaoSemanalDia,
        repeticaoMensalOpcao,
        every,
    ] = watch([
        'dataInicial',
        'tipoRepeticao',
        'repeticaoSemanalDia',
        'repeticaoMensalOpcao',
        'every',
    ])

    return (
        <RA.Root
            className="w-full"
            value={tipoRepeticao}
            onValueChange={v => {
                if (v) setValue('tipoRepeticao', v as any)
            }}
        >
            {errors.tipoRepeticao && (
                <p className="text-error text-xs">
                    {errors.tipoRepeticao.message}
                </p>
            )}
            <RA.Item value="DIARIO">
                <RA.Trigger>
                    A cada&nbsp;
                    <FieldEvery />
                    &nbsp;dia(s)
                    {tipoRepeticao === 'DIARIO' && errors.every && (
                        <p className="text-error text-xs ml-2">
                            {errors.every.message}
                        </p>
                    )}
                </RA.Trigger>
                <RA.Content className="flex flex-col gap-4 text-balance">
                    {(() => {
                        const inicio = dayjs.utc(
                                dataInicial || dayjs.utc().format('YYYY-MM-DD'),
                            ),
                            everyValue = Number(every || 1)

                        return (
                            <p className="text-xs w-full">
                                Troca a cada {everyValue} dia
                                {everyValue < 2 ? '' : 's'} significa que a
                                primeira troca vai ocorrer em&nbsp;
                                {inicio.format('DD/MM/YYYY')}
                                &nbsp; e a segunda troca deve ocorrer no
                                dia&nbsp;
                                {inicio
                                    .add(everyValue + 1, 'day')
                                    .format('DD/MM/YYYY')}
                                .
                            </p>
                        )
                    })()}
                </RA.Content>
            </RA.Item>
            <RA.Item value="SEMANAL">
                <RA.Trigger>
                    A cada&nbsp;
                    <FieldEvery />
                    &nbsp;semana(s)
                    {tipoRepeticao === 'SEMANAL' && errors.every && (
                        <p className="text-error text-xs ml-2">
                            {errors.every.message}
                        </p>
                    )}
                </RA.Trigger>
                <RA.Content className="flex flex-col gap-4 text-balance">
                    <RadioGroup
                        value={repeticaoSemanalDia.toString()}
                        onValueChange={v =>
                            setValue('repeticaoSemanalDia', parseInt(v))
                        }
                    >
                        <div className="flex gap-2 w-full justify-evenly">
                            {Array.from({ length: 7 }, (_, i) => (
                                <div key={i} className="flex items-center">
                                    <RadioGroupItem
                                        value={i.toString()}
                                        id={`day-${i}`}
                                        className="sr-only"
                                    />
                                    <Label
                                        htmlFor={`day-${i}`}
                                        className={cn(
                                            'cursor-pointer px-3 py-2 text-sm font-medium',
                                            'border-2 border-transparent rounded-full transition-all',
                                            'hover:bg-primary/10',
                                            repeticaoSemanalDia == i
                                                ? 'border-primary text-primary'
                                                : i === 0
                                                  ? 'text-error'
                                                  : '',
                                        )}
                                    >
                                        {dayjs()
                                            .day(i)
                                            .format('ddd')
                                            .charAt(0)
                                            .toUpperCase() +
                                            dayjs()
                                                .day(i)
                                                .format('ddd')
                                                .slice(1)}
                                    </Label>
                                </div>
                            ))}
                        </div>
                        <p className="text-xs w-full">
                            A primeira troca deverá ocorrer no dia&nbsp;
                            <span className="font-semibold">
                                {(() => {
                                    const inicio = dayjs.utc(
                                        dataInicial ||
                                            dayjs.utc().format('YYYY-MM-DD'),
                                    )
                                    const data = inicio.day(repeticaoSemanalDia)
                                    return data.isBefore(inicio, 'day')
                                        ? inicio.format('DD/MM/YYYY')
                                        : data.format('DD/MM/YYYY')
                                })()}
                            </span>
                            .
                        </p>
                    </RadioGroup>
                </RA.Content>
            </RA.Item>
            <RA.Item value="MENSAL">
                <RA.Trigger>
                    A cada&nbsp;
                    <FieldEvery />
                    &nbsp;mes(es)
                    {tipoRepeticao === 'MENSAL' && errors.every && (
                        <p className="text-error text-xs ml-2">
                            {errors.every.message}
                        </p>
                    )}
                </RA.Trigger>
                <RA.Content className="flex flex-col gap-4 text-balance">
                    <RadioGroup
                        value={repeticaoMensalOpcao}
                        onValueChange={v =>
                            setValue('repeticaoMensalOpcao', v as any)
                        }
                    >
                        <div className="flex flex-col gap-2 w-full justify-evenly">
                            <div>
                                <RadioGroupItem
                                    value="DIA"
                                    id="DIA"
                                    className="sr-only"
                                />
                                <Label
                                    htmlFor="DIA"
                                    className={cn(
                                        'cursor-pointer px-3 py-2 text-sm font-medium',
                                        'border-2 border-transparent rounded-full transition-all',
                                        'hover:bg-primary/10',
                                        repeticaoMensalOpcao === 'DIA'
                                            ? 'border-primary text-primary'
                                            : '',
                                    )}
                                >
                                    Todo dia{' '}
                                    {dayjs
                                        .utc(
                                            dataInicial ||
                                                dayjs
                                                    .utc()
                                                    .format('YYYY-MM-DD'),
                                        )
                                        .date()}{' '}
                                    do mês
                                </Label>
                            </div>
                            <div>
                                <RadioGroupItem
                                    value="SEMANA"
                                    id="SEMANA"
                                    className="sr-only"
                                />
                                <Label
                                    htmlFor="SEMANA"
                                    className={cn(
                                        'cursor-pointer px-3 py-2 text-sm font-medium',
                                        'border-2 border-transparent rounded-full transition-all',
                                        'hover:bg-primary/10',
                                        repeticaoMensalOpcao === 'SEMANA'
                                            ? 'border-primary text-primary'
                                            : '',
                                    )}
                                >
                                    <SpanWeekDay />
                                </Label>
                            </div>
                        </div>
                    </RadioGroup>
                    {repeticaoMensalOpcao === 'DIA' && (
                        <p className="text-xs w-full">
                            Se a troca for no dia 31 e o mês for fevereiro, com
                            apenas 28 dias, a troca será feita no dia 3 de
                            março. Se o mês tiver apenas 30 dias e a troca for
                            no dia 31, a troca será feita no dia 1º do próximo
                            mês.
                        </p>
                    )}
                    {repeticaoMensalOpcao === 'SEMANA' && (
                        <p className="text-xs w-full">
                            Se a troca for na 5ª semana e o mês não tiver o dia
                            específico na semana, a troca será feita na 1ª
                            semana do mês seguinte.
                        </p>
                    )}
                </RA.Content>
            </RA.Item>
        </RA.Root>
    )
}

function SpanWeekDay() {
    const { watch } = useFormContext<TrocaAutomaticaTabela>()
    const dataInicial = watch('dataInicial')

    const { ordinal, diaSemana, semana, artigo } =
        calcularRepeticao(dataInicial)

    return (
        <>
            Tod{artigo} {semana}
            {ordinal} {diaSemana} do mês
        </>
    )
}

function FieldEvery() {
    return (
        <FormField
            name="every"
            type="number"
            variant="standard"
            className="w-7 z-1 text-sm! text-center"
            onClick={e => e.stopPropagation()}
            min={0}
            max={999}
            placeholder="1"
            unHelperText
        />
    )
}

export function calcularRepeticao(dataInicial?: string | Date) {
    const dataInicialDayjs = dayjs.utc(
        dataInicial || dayjs.utc().format('YYYY-MM-DD'),
    )

    const indicadorOrdinal =
        dataInicialDayjs.day() === 0 || dataInicialDayjs.day() === 6 ? 'º' : 'ª'

    return {
        /* 'ª' ou 'º' */
        ordinal: indicadorOrdinal,
        /* Dia da semana em extenso */
        diaSemana: dataInicialDayjs.format('dddd'),
        /* Calcula qual semana do mês é baseado no dia da data */
        semana: Math.floor((dataInicialDayjs.date() - 1) / 7) + 1,
        /* 'o' ou 'a' */
        artigo: indicadorOrdinal === 'º' ? 'o' : 'a',
    }
}
